export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    SectionResult: [
      'Ancillary',
      'AngleSection',
      'BaseplateSection',
      'BeamSection',
      'CapplateSection',
      'CleatSection',
      'ColumnSection',
      'CrossBraceSection',
      'DeckingSection',
      'JoistSection',
      'StrutSection',
    ],
  },
};
export default result;
